import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=c01d56c2&scoped=true&"
import script from "./MainSlide.vue?vue&type=script&lang=js&"
export * from "./MainSlide.vue?vue&type=script&lang=js&"
import style0 from "./MainSlide.vue?vue&type=style&index=0&id=c01d56c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d56c2",
  null
  
)

export default component.exports